module.exports = __webpack_public_path__ + "static/img/pay.f33fda25.svg";